// Nombre clave de la herramienta para ingresar texto
export const KEY_TEXT_TOOL_OPTION = 'texto';

// Estados del panning dentro del canvas
export const STATE_IDLE = 'idle';
export const STATE_PANNING = 'panning';

// Escala del zoom
export const SCALE_ZOOM = 0.15;

// Endpoint al cual se sube la imagen y se obtiene su enlace público
export const ENDPOINT_IMGBB = APP_CONF.API_TOKEN_IMGBB;
